import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const UPDATE_STATEMENT_OPERATION = gql`
  mutation UpdateStatementOperation(
    $statementOperationUuid: ID!
    $oldValueDate: Date!
    $updatedStatementOperation: StatementOperationInputDto!
  ) {
    updateStatementOperation(
      statementOperationUuid: $statementOperationUuid
      oldValueDate: $oldValueDate
      updatedStatementOperation: $updatedStatementOperation
    ) {
      uuid
      consultantUuid
      valueDate
      operationType
      amount
      amountEur
      currency
      comment
      linkedEntityUuid
      linkedEntityPeriod
      beforeBalance
      afterBalance
      impactsOverflow
      editable
    }
  }
`;

export const useUpdateStatementOperation = () => {
  const [updateStatementOperation, { loading, error, data }] = useMutation(UPDATE_STATEMENT_OPERATION);

  return {
    updateStatementOperation,
    loading,
    error,
    data: data?.updateStatementOperation,
  };
};

export default useUpdateStatementOperation;
